import { Box, Text, Button } from "rebass/styled-components";
import Heading from "./Heading";
import { headlineStyles as styles } from "../../lib/styles/landingStyles";

interface HeadlineProps {
  variant: string;
  title: string;
  subtitle?: string;
  textAlign?: any;
  buttonTitle?: any;
  onSubmit?: () => void;
}

function Headline(props: HeadlineProps) {
  const {
    variant,
    title,
    subtitle,
    buttonTitle,
    onSubmit,
    textAlign = false
  } = props;

  const containerStyle = styles.box[variant as keyof typeof styles.box];

  return (
    <Box sx={{ ...containerStyle, textAlign: textAlign }}>
      <Heading as="h2" sx={styles.title}>
        {title}
      </Heading>
      {subtitle && (
        <Text as="h3" sx={styles.subtitle}>
          {subtitle}
        </Text>
      )}
      {buttonTitle && (
        <Box sx={styles.boxButton}>
          <Button variant="primary" sx={styles.button} onClick={onSubmit}>
            {buttonTitle}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default Headline;
